import { ReactElement } from 'react';

type Props = {
  chip: string;
  onClick: () => void;
};

/**
 * Component to display chips for filter.
 * @param props - Properties of Filter Chip.
 * @returns - Filter chip component.
 */
export default function FilterChip(props: Props): ReactElement {
  const { onClick, chip } = props;
  return (
    <div className="flex items-center border border-gray-600 rounded px-1 py-1 w-fit gap-2 h-7">
      <div className="text-gray-300 font-medium text-xs">{chip}</div>
      <button
        onClick={onClick}
        type="button"
        style={{ fontSize: 12 }}
        className="material-icons-outlined text-gray-700 hover:text-gray-300"
      >
        close
      </button>
    </div>
  );
}
